import BarChart from '../../charts/barChart'
import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      chartWidth: 900,
      chartKey: false,
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      preventiveScheduleXExecuted: undefined,
      page: 1,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        interaction: {
          mode: 'index',
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: true,
            color: '#fff',
            anchor: 'center',
            align: 'center',
            font: {
              size: 11,
              weight: 'bold',
            },
            rotation: -90,
            formatter: (value) => {
              return value > 0 ? value : ''
            },
          },
        },
      },
      preventiveScheduleXExecutedChartData: {},
      preventiveSchedule: [],
      preventiveExecuted: [],
      internalPreventiveExecuted: [],
      internalPreventiveSchedule: [],
      labels: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },
  async created() {
    this.listpreventiveScheduleXExecuted()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `1.11 - Preventivas Agendadas x Executadas - Acumulado.xlsx`
      this.apiService
        .post('excel/preventiveScheduleExecuted', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listpreventiveScheduleXExecuted() {
      await this.apiService
        .post('reports/preventiveScheduleExecuted', this.filterProp)
        .then((response) => {
          this.data = response.content
          this.fillpreventiveScheduleXExecutedChartData()
        })
        .catch((err) => {})
    },
    fillpreventiveScheduleXExecutedChartData() {
      const labels = this.data.dataByMonth.map((x) => x.month);
      const labelsCount = labels.length;
      const widthPerMonth = 70;
      this.chartWidth = Math.max(labelsCount * widthPerMonth, 900);
      this.preventiveScheduleXExecutedChartData = {
        labels,
        datasets: [
          {
            label: this.$t('Meta'),
            type: 'line',
            data: this.data.dataByMonth.map(x => this.data.goal),
            borderColor: 'orange',
            backgroundColor: 'rgba(255,128,0,0.1)',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Execução total'),
            data: this.data.dataByMonth.map(x => x.totalPercentage),
            backgroundColor: '#aaa',
          },
          {
            label: this.$t('Execução interna'),
            data: this.data.dataByMonth.map(x => x.percentage),
            backgroundColor: '#bbcf20',
          },
          {
            label: this.$t('Execução externa'),
            data: this.data.dataByMonth.map(x => x.externalPercentage),
            backgroundColor: '#0288d1',
          },
        ],
      };
      setTimeout(() => {
        this.chartKey = !this.chartKey;
      }, 100);
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listpreventiveScheduleXExecuted()
    },
  },
}
